import { useState, useEffect, useMemo } from 'react'
import QRCode from 'qrcode'
import { EasyImg } from 'src/components'
import { mainStore } from 'enasops/stores'
import { getFileUrl } from 'enasops/utils/axios'
import { getPathnameParams } from 'src/utils/tools'

const Download = (props: { url: string }) => {
  const [src, setSrc] = useState<string>()

  const downloadUrl = useMemo(() => {
    return getFileUrl(props.url ? JSON.parse(props.url)[0]?.FilePath : '') ?? ''
  }, [props.url])

  useEffect(() => {
    if (props.url) {
      const code = getPathnameParams()
      const site = `${mainStore.baseConfig.ConsoleUrl ?? 'http://localhost:3000'}/${code[0] ?? 'abc'}/#/app-download`
      QRCode.toDataURL(`${site}?url=${downloadUrl}`).then(url => {
        setSrc(url)
      })
    }
  }, [downloadUrl])

  return (
    <div className='text-center'>
      <h3 style={{ textAlign: 'left' }}>APP下载</h3>
      <EasyImg src={src} style={{ width: 160, height: 160, marginBottom: 8 }} />
      <br />
      <a download href={downloadUrl}>安装包下载到本地</a>
    </div>
  )
}

export default Download